import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { OdsServices } from '../../services';
import { TakeawayServices } from '../../../takeaway/services';
import { ConfigurationPaymentStripePage } from '../../../configuration/configuration-payment-methods/configuration-payment-stripe/configuration-payment-stripe';
import { ConfigurationPaymentPaypalPage } from '../../../configuration/configuration-payment-methods/configuration-payment-paypal/configuration-payment-paypal';
import { ConfigurationPaymentRedsysPage } from '../../../configuration/configuration-payment-methods/configuration-payment-redsys/configuration-payment-redsys';
import { ConfigurationPaymentRedsysBizumPage } from '../../../configuration/configuration-payment-methods/configuration-payment-redsys-bizum/configuration-payment-redsys-bizum';
import { ConfigurationPaymentTakeawayPage } from '../../../configuration/configuration-payment-methods/configuration-payment-takeaway/configuration-payment-takeaway';

/**
 * Generated class for the OdsListViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ods-config-payments',
    templateUrl: 'ods-config-payments.html',
})
export class OdsConfigPaymentsPage {

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public translate: TranslateService,
        public globals: Globals,
        public toastCtrl: ToastController,
        public odsServices: OdsServices,
        public takeawayServices: TakeawayServices) {
    }

    openTakeaway() {
        this.navCtrl.push(ConfigurationPaymentTakeawayPage);
    }

    openStripe() {
        this.navCtrl.push(ConfigurationPaymentStripePage);
    }

    openPaypal() {
        this.navCtrl.push(ConfigurationPaymentPaypalPage);
    }

    openRedsys() {
        this.navCtrl.push(ConfigurationPaymentRedsysPage);
    }

    openRedsysBizum() {
        this.navCtrl.push(ConfigurationPaymentRedsysBizumPage);
    }

    ionViewWillLeave() {
        if (!this.odsServices.takeaway_config.config_payments) {
            this.odsServices.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/takeaway').doc('config').update({
                config_payments: true
            });
            this.odsServices.takeaway_config.config_payments = true;
        }
    }

    save() {
        this.navCtrl.pop();
    }
}


// WEBPACK FOOTER //
// ./src/pages/ods/ods-config/ods-config-payments/ods-config-payments.ts